import { renderV2 } from 'base/wrapped-render-v2';

import Ctrl, {
	onReady,
} from 'ctrl.deco';
import { getJsonData } from 'Data.util';
import { AccessDeniedPage } from './403';

@Ctrl('/403.php*')
class AccessDeniedErrorCtrl {
	@onReady()
	ready() {
		const accessDeniedRoot = document.getElementById('js-access-denied-page');
		const accessDeniedData = getJsonData('#js-accessDeniedData');

		if (accessDeniedRoot) {
			renderV2({
				children: <AccessDeniedPage {...accessDeniedData} />,
				attachedElement: accessDeniedRoot,
			});
		}
	}
}